
import React from 'react';
import { sprintf } from "sprintf-js";

class Popup extends React.Component {

  render = () => {
    const transform = sprintf("translate(%s, %s)",
      this.props.translate_x || "0",
      this.props.translate_y || "0");
    const dropdown_style = {
      pointerEvents: "auto",
      display: "block",
      position: "absolute",
      transform: transform,
      backgroundColor: "#FFF",
      cursor: "pointer",
      boxShadow: "0.5rem 0.5rem 1rem 0 rgba(0, 0, 0, 0.4)",
      zIndex: "50",
      ...this.props.style,
    };
    const popup_id = this.props.popup_id;
    const mouse_over_cb = this.props.onMouseOver && this.props.onMouseOver(popup_id, true);
    const mouse_out_cb = this.props.onMouseOver && this.props.onMouseOver(popup_id, false);
    return (
      <div
        style={dropdown_style}
        onMouseEnter={mouse_over_cb}
        onMouseLeave={mouse_out_cb}
        onClick={ev => ev.stopPropagation()}>
        { this.props.children }
      </div>
    );
  }
}

const PopupBorder = props => {
  const border_style = {
    border: "2px solid black",
    padding: "0.2rem 1rem",
  };
  return (
    <div style={border_style}>
      { props.children }
    </div>
  )
};

export { Popup, PopupBorder };
